import React from "react"
import Panel, { Content, CommandBar, Command } from "../Panel"
import { Form } from "semantic-ui-react"
import ImageAsset from "../ImageAsset"
import FocusElement from "../FocusElement"
import get from "lodash.get"
import CategoryContainer from "./CategoryContainer"
import Draft from "../Draft"
import merge from "lodash.merge"
import { push } from "../history"

export default ({ onCreate, onUpdate, onDelete, ...props }) => (
  <CategoryContainer
    id={
      props.match.params.categoryId !== `new` && props.match.params.categoryId
    }
    onCreate={onCreate}
    onUpdate={onUpdate}
    onDelete={onDelete}
  >
    {category => (
      <Draft
        key={get(category, `data.id`)}
        original={merge(
          {},
          {
            name: get(props, `location.state.name` || ``),
          },
          category.data
        )}
      >
        {draft => (
          <Panel
            title={
              category.loading
                ? `Loading category...`
                : get(
                    category,
                    `data.name`,
                    `Add: ${ get(draft, `state.name`, ``) }`
                  )
            }
            onClose={() => push(props.returnTo || `/categories`)}
          >
            <FocusElement>
              {({ elementRef, focusElement }) => (
                <React.Fragment>
                  <CommandBar>
                    {get(draft, `state.id`) && (
                      <Command.Delete onClick={category.delete} />
                    )}
                    <Command
                      save
                      ref={elementRef}
                      disabled={
                        (get(draft, `state.id`) && !draft.dirty) ||
                        !get(draft, `state.name`)
                      }
                      onClick={() => category.save(draft.state)}
                    />
                  </CommandBar>
                  <Content
                    loading={category.loading}
                    loadingText={category.loadingMessage}
                  >
                    <Form autoComplete="off" style={{ marginBottom: `2rem` }}>
                      <Form.Input
                        required
                        name="name"
                        label="Name"
                        value={get(draft, `state.name`, ``)}
                        onChange={draft.handleChange}
                      />

                      <Form.TextArea
                        name="description"
                        label="Description"
                        value={get(draft, `state.description`, ``)}
                        onChange={draft.handleChange}
                        onKeyDown={focusElement}
                      />

                      <Form.Field>
                        <label>Image</label>
                        <ImageAsset
                          name="image"
                          initialValue={get(draft, `state.image.url`)}
                          onChange={draft.handleChange}
                        />
                      </Form.Field>

                      {get(draft, `state.id`) && (
                        <React.Fragment>
                          <Form.Field>
                            <label>Created</label>
                            <p>
                              {draft.state.createdUtc &&
                                new Date(draft.state.createdUtc).toLocaleString(
                                  navigator.language
                                )}
                            </p>
                          </Form.Field>
                          <Form.Field>
                            <label>Updated</label>
                            <p>
                              {draft.state.updatedUtc &&
                                new Date(draft.state.updatedUtc).toLocaleString(
                                  navigator.language
                                )}
                            </p>
                          </Form.Field>
                        </React.Fragment>
                      )}
                    </Form>
                  </Content>
                </React.Fragment>
              )}
            </FocusElement>
          </Panel>
        )}
      </Draft>
    )}
  </CategoryContainer>
)
